import { Permission } from '@/shared/model/permission';
import { User } from '@/shared/model/user';

export const checkUserPermission = (user: User, permissions: Permission[]) => {
  return user.permissions?.some((p: Permission) => permissions?.includes(p));
};
